import TYPE from 'src/redux/actions/TYPE';

const initialState = {
  list: [],
  customerList: [],
  globalList: []
};

const bank = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.GET_LIST_BANK_SUCCESS:
      return {
        ...state,
        list: action.payload
      };

    case TYPE.RESET_BANK:
      return {
        ...state,
        list: []
      };

    case TYPE.GET_LIST_CUSTOMER_BANK_SUCCESS:
      return {
        ...state,
        customerList: action.payload
      };

    case TYPE.GET_LIST_GLOBAL_BANK_SUCCESS:
      return {
        ...state,
        globalList: action.payload
      };

    default:
      return state;
  }
};

export default bank;
